module.exports = __webpack_public_path__ + "img/upperBody.b1043186.svg";